/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Custompage_ReadInputs */

const en_enum_permission_name_custompage_read = /** @type {(inputs: Enum_Permission_Name_Custompage_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompage Read`)
};

const de_enum_permission_name_custompage_read = /** @type {(inputs: Enum_Permission_Name_Custompage_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompage Read`)
};

/**
* | output |
* | --- |
* | "Name Custompage Read" |
*
* @param {Enum_Permission_Name_Custompage_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_custompage_read = /** @type {((inputs?: Enum_Permission_Name_Custompage_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Custompage_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_custompage_read(inputs)
	return de_enum_permission_name_custompage_read(inputs)
});